import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const OfferFitUseCases = lazy(() =>
  import("@scenes/OfferFit/components/OfferFitUseCases").then((module) => ({
    default: module.OfferFitUseCases,
  }))
);

export const offerfitUseCasesNRO: NavigationRoutingObject = {
  Component: OfferFitUseCases,
  componentFeatureFlippers: ["offerfit_dashboard"],
  noKnockoutFallback: true,
  section: "offerfit",
  heading: (t: I18nT<"dashboard-navigation">) => t("offerfit-by-braze", "BrazeAI Decisioning Studio™"),
  pageNameForTracking: () => "BrazeAI Decisioning Studio™",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("offerfit-use-cases-nro-description", "See how your BrazeAI Decisioning Studio™ agents are performing"),
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission, isImpersonating }) => {
    if (!featureOn("offerfit_dashboard")) {
      return false;
    }

    const userHasViewDecisioningStudioAgentsPermission = hasPermission("appGroup", {
      permission: "viewDecisioningStudioAgents",
    });

    return isImpersonating || userHasViewDecisioningStudioAgentsPermission;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/decisioning_studio/agents/:appGroupId",
};
